export enum AttachmentCategory {
  'DD1222' = 0,
  'LabReport' = 1
}
